import React from "react";
import Script from "next/script";

import { NEWSLETTER_TOUT_CLASSES } from "~constants";
import { ARTICLE_TYPE } from "~types/types";

const ASSET_HOST = process.env.NEXT_PUBLIC_ASSET_HOST;

const PLUG_SCRIPT_SRC = `//${ASSET_HOST}/s3/fence/plug-client/v0/app.bundle.js`;

const PLUG_SUPPORTED_ARTICLE_TYPES = [ARTICLE_TYPE.BASIC, ARTICLE_TYPE.FEATURE];

// Plug is only initializied once, and does not currently apply to transported articles
let initialized = false;

export function initPlug() {
    return () => {
        if (
            !initialized &&
            typeof window !== "undefined" &&
            window.plugClient
        ) {
            const config = {
                "top-of-content": `.${NEWSLETTER_TOUT_CLASSES.top}`,
                "middle-of-content": `.${NEWSLETTER_TOUT_CLASSES.middle}`,
                "bottom-of-content": `.${NEWSLETTER_TOUT_CLASSES.bottom}`,
                banner: ".custom-banner",
            };
            window.plugClient.init(config);
            initialized = true;
        }
    };
}

export function PlugScript() {
    return (
        <Script
            src={PLUG_SCRIPT_SRC}
            id="plug-client-snippet"
            onReady={initPlug()}
            strategy="lazyOnload"
        />
    );
}

export function plugSupportedType(articleType: ARTICLE_TYPE) {
    return PLUG_SUPPORTED_ARTICLE_TYPES.includes(articleType);
}
